module.exports = __webpack_public_path__ + "static/media/multiactionarrow.2ea1004e.svg";